import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { detectBrowser } from 'libs/browser';
import { useSession } from 'components/Authenticated';
import * as clientEnv from 'libs/client-env';
import { useBeeyTutorial } from 'screens/DashboardScreen/beeyTutorial';
import { useSubModeTutorial } from '../contexts/subModeTutorial';
import { usePlaybackContext } from '../contexts/playback';
const EditorKeyboardControls = ({ className, children, waveCanvas, replayCaption, hasRecording, }) => {
    var _a;
    const { playback, playerState } = usePlaybackContext();
    const { session } = useSession();
    const { settings } = session.login.user;
    const operatingSystem = (_a = detectBrowser()) === null || _a === void 0 ? void 0 : _a.os;
    const beeyTutorialContext = useBeeyTutorial();
    const subModeTutorialContext = useSubModeTutorial();
    useEffect(() => {
        const suppressBrowserAltMenu = (event) => {
            if (event.key === 'Alt') {
                event.preventDefault();
            }
        };
        window.addEventListener('keyup', suppressBrowserAltMenu);
        return () => {
            window.removeEventListener('keyup', suppressBrowserAltMenu);
        };
    }, []);
    const handleKeyDown = (event) => {
        if (event.key === 'ArrowLeft' && event.altKey) {
            event.preventDefault();
            return false;
        }
        if (event.key === 'Left' && event.altKey) {
            event.preventDefault();
            return false;
        }
        if (event.key === 'Right' && event.altKey) {
            event.preventDefault();
            return false;
        }
        const ctrlOrAltKey = operatingSystem === 'Mac OS' || operatingSystem === 'iOS'
            ? event.ctrlKey
            : event.altKey;
        const isPlaybackShortcut = ((event.nativeEvent.code === 'KeyJ' && ctrlOrAltKey)
            || (event.nativeEvent.code === 'KeyL' && ctrlOrAltKey)
            || (event.nativeEvent.code === 'KeyN' && ctrlOrAltKey)
            || (event.nativeEvent.code === 'KeyM' && ctrlOrAltKey)
            || (event.nativeEvent.code === 'Comma' && ctrlOrAltKey)
            || (event.nativeEvent.code === 'Period' && ctrlOrAltKey)
            || (event.nativeEvent.code === 'KeyP' && event.altKey));
        const canHandlePlaybackShortcuts = playerState.status === 'ready' && hasRecording === true;
        if (!canHandlePlaybackShortcuts) {
            if (hasRecording === false && isPlaybackShortcut) {
                event.preventDefault();
                return false;
            }
            return true;
        }
        if (event.key === 'Tab') {
            if (event.shiftKey) {
                if (beeyTutorialContext.currentStep === 2) {
                    beeyTutorialContext.tutorialGoNext();
                }
            }
        }
        if ((event.key === 'Backspace' || event.key === 'Delete') && subModeTutorialContext.currentStep === 3) {
            subModeTutorialContext.tutorialGoNext();
        }
        // Ctrl key for Mac, iPhones and iPads, Alt key for the others OS
        // https://github.com/DamonOehlman/detect-browser/blob/master/src/index.ts#L169
        if (event.nativeEvent.code === 'KeyJ' && ctrlOrAltKey) {
            event.preventDefault();
            playback.stepTimeBy(-1.0 * settings.jumpInPlayback);
            return false;
        }
        if (event.nativeEvent.code === 'KeyL' && ctrlOrAltKey) {
            event.preventDefault();
            playback.stepTimeBy(+1.0 * settings.jumpInPlayback);
            return false;
        }
        if (event.nativeEvent.code === 'KeyN' && ctrlOrAltKey) {
            event.preventDefault();
            playback.slowDown();
            clientEnv.setPlayerSpeed(playback.speed);
            return false;
        }
        if (event.nativeEvent.code === 'KeyM' && ctrlOrAltKey) {
            event.preventDefault();
            playback.speedUp();
            clientEnv.setPlayerSpeed(playback.speed);
            return false;
        }
        if (event.nativeEvent.code === 'Comma' && ctrlOrAltKey) {
            event.preventDefault();
            playback.stepTimeBy(-0.04);
            return false;
        }
        if (event.nativeEvent.code === 'Period' && ctrlOrAltKey) {
            event.preventDefault();
            playback.stepTimeBy(0.04);
            return false;
        }
        if (event.nativeEvent.code === 'KeyB' && event.ctrlKey) {
            event.preventDefault();
            if (subModeTutorialContext.currentStep === 0) {
                subModeTutorialContext.tutorialGoNext();
            }
            return false;
        }
        if (waveCanvas !== null && (event.nativeEvent.code === 'KeyP' && event.altKey)) {
            event.preventDefault();
            replayCaption();
            return false;
        }
        return true;
    };
    return (_jsx("div", { role: "presentation", className: className, onKeyDown: handleKeyDown, children: children }));
};
export default EditorKeyboardControls;
